import {Params} from '../types';
import {hasParams} from './hasParams';

/**
 * Serializuje parametry do query string v URL.
 *
 * @param params - Parametry.
 * @returns Výsledný řetězec.
 * @ignore
 */
export function serializeParams(params: Params | undefined): string {
    if (!hasParams(params)) {
        return '';
    }
    return Object.keys(params!)
        .sort() // Potřebujeme aby to bylo deterministické kvůli testům
        .filter(key => params![key] != null)
        .map(key => `${key}=${params![key]}`)
        .join('&');
}
